<template>
    <router-view/>
</template>

<script>
    export default {
        name: "TeknikDestek"
    }
</script>

<style scoped>

</style>